@use '../../style//utils';

.joy-dropzone {
    --spinner-size: 20px;
    font-family: var(--joy-font-family);
    font-size: var(--joy-font-size-primary-300);

    label {
        width: 100%;
    }

    input {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0,0,0,0);
        border: 0;
    }

    &__area {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        background-color: white;
        border: var(--joy-form-border-width) dashed var(--joy-color-neutral-40);
        padding: var(--joy-core-spacing-4);
        border-radius: var(--joy-core-radius-3);
        transition: all 0.3s ease;
        font-size: var(--joy-font-size-primary-400);
        color: var(--joy-color-text-body);
        width: 100%;
        
        @media screen and (max-width: 700px) {
            padding: var(--joy-core-spacing-2);
        }
    }

    &__description {
        @include utils.getFontProperties(primary-400);
        margin: 0;
    }

    &__plus-icon, &__file-icon {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 40px;
        height: 40px;
        border-radius: var(--joy-core-radius-2);
    }

    &__plus-icon {
        background-color: var(--joy-color-secondary-10);
    }

    &__file-icon {
        background-color: var(--joy-color-success-10);
        
        joy-icon {
            color: var(--joy-color-neutral-60);
        }
    }

    &__cta {
        margin-left: auto;

        joy-icon {
            cursor: pointer;
            color: var(--joy-color-neutral-60);
            transition: color 0.3s ease;

            &:hover {
                color: var(--joy-color-neutral-40);
            }
        }
    }

    &__info {
        margin-top: var(--joy-core-spacing-2);
        color: var(--joy-color-neutral-40);
        font-size: var(--joy-font-size-primary-200);
    }

    &__loader {
        position: relative;
        left: calc(var(--spinner-size) / -2);
        height: var(--spinner-size);
        width: var(--spinner-size);
        margin: 0 auto var(--joy-core-spacing-4);
    }

    &__item {
        display: flex;
        justify-content: center;
        align-items: baseline;

        span {
            display: block;
            color: var(--joy-color-neutral-60);
            margin-right: var(--joy-core-spacing-2);
            @include utils.getFontProperties(primary-350);
        }
    }

    &__file___wrapper {
        &:not(:last-child) {
            margin-bottom: var(--joy-core-spacing-4);
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    &:hover:not(&--disabled, &--invalid),
    &--focusing {
        .joy-dropzone__area {
            border-color: var(--joy-color-secondary-30);
        }
    }

    &--invalid {
        .joy-dropzone__area {
            border-color: var(--joy-color-error-50);
            border-style: solid;
        }
    }

    &--valid {
        .joy-dropzone__area {
            border-style: solid;
            border-color: var(--joy-color-neutral-30);
        }
    }

    &--disabled {
        label {
            cursor: not-allowed;
        }
        .joy-dropzone__area {
            cursor: not-allowed;
            border-color: var(--joy-color-neutral-30);
        }
    }
}